var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "popup-form property-popup-form"
  }, [_c('div', {
    staticClass: "content-form-popup"
  }, [_c('div', {
    staticClass: "property-popup-heading"
  }, [_c('button', {
    staticClass: "property-close-button",
    attrs: {
      "type": "button",
      "aria-label": "Zavrieť nehnuteľnosť"
    },
    on: {
      "click": _vm.closePopup
    }
  }, [_c('img', {
    staticClass: "nav-link-icon filter-primary",
    attrs: {
      "src": require("@/images/modal-close.svg"),
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "property-popup-title"
  }, [_vm._v(" " + _vm._s(_vm.payload ? "Úprava" : "Pridanie") + " " + _vm._s(_vm.getPropertyDataBySubType(_vm.type.child_type).label) + " ")]), _c('button', {
    staticClass: "property-save-button",
    attrs: {
      "type": "submit",
      "form": "property-submit"
    }
  }, [_vm._v("Uložiť")])]), _c('property-form', {
    attrs: {
      "druh": _vm.type.druh,
      "type": _vm.getPropertyDataBySubType(_vm.type.child_type),
      "property": _vm.payload,
      "banks": _vm.banks,
      "form-template": _vm.form
    },
    on: {
      "property-saved": function propertySaved($event) {
        return _vm.saveProperty($event);
      }
    }
  }), _vm.cloud && _vm.cloud.missingFiles.length > 0 ? _c('div', [_c('div', {
    staticClass: "splitter"
  }, [_vm._v("Podklady")]), _vm._l(_vm.cloud.missingFiles, function (missingFile, index) {
    return _c('document-cloud-handler', {
      key: index,
      attrs: {
        "title": missingFile.name,
        "type": missingFile.id,
        "uploaded": missingFile.uploaded,
        "class-cst": 'upload-item-broker-custom',
        "cloud-meta": _vm.cloud.cloudMeta,
        "rules": ['single'],
        "text-button": ""
      }
    });
  })], 2) : _vm._e()], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }